// composables/useStudioImages.ts
import { ref } from "vue";

export function useStudioImages() {
  const images = ref<any[]>([]);
  const loading = ref(true);
  const error = ref<string | null>(null);

  const fetchImages = async () => {
    loading.value = true;
    error.value = null;

    try {
      const { data, error: fetchError } = await useFetch("/api/studioImages");

      if (fetchError.value) {
        throw new Error(fetchError.value);
      }

      images.value = data.value.items;
    } catch (err: any) {
      error.value = err.message || "Failed to fetch studio images";
    } finally {
      loading.value = false;
    }
  };

  fetchImages();

  return {
    images,
    loading,
    error,
    fetchImages,
  };
}
